<template>
  <div>
    <div>
      <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading>
    </div>

    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="
            border-radius: 5px !important;
            padding-left: 0px;
            height: auto !important;
          " toggleable="lg" type="dark" variant="primary">
          <b-navbar-brand center>Location Details</b-navbar-brand>

          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <!-- <b-button
                class="ml-2"
                type="submit"
                size="sm"
                variant="primary"
                @click="ExportAccountExcel"
                >Export as Excel</b-button
              > -->
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>
        <b-row>
          <b-col md="6"></b-col>
          <b-col md="2">
            <label for="clientId">Location Type</label>
            <model-list-select :list="LocationTypeNameFilter" v-model="locationTypeFilter"
              option-value="LocationTypeVal" option-text="LocationTypeText" placeholder="Select Location Type"
              @input="getData('0', '1', '1')"></model-list-select>
          </b-col>
          <b-col md="2" v-if="
            $sessionsStorage.get('nameUser') == 'Bhavneesh' ||
            $sessionsStorage.get('cust_username') == 'admin'
          ">
           <label for="clientId">Status</label>
            <model-list-select :list="StatusTypeList" v-model="Status" option-value="StatusTypeVal"
              option-text="StatusTypeTxt" placeholder="Select Status" @input="getData"></model-list-select>
          </b-col>
          <b-col md="1">
            <b-button size="sm" variant="warning" v-if="showMain == false" @click="goToMain" class="mr-3">New
              Location</b-button>
          </b-col>
          <b-col md="1">
            <b-button :disabled="ExcelBtnName != 'Export to Excel' ? true : false"
              @click="getReportsAss('All_Location_Master_Report', 'Export to Excel')" class="ml-3" size="sm"
              variant="primary">
              {{ ExcelBtnName }}
              <b-spinner v-if="ExcelBtnName != 'Export to Excel'" small label="Small Spinner"></b-spinner></b-button>
          </b-col>
        </b-row>

        <div v-if="showMain == true">
          <div>
            <b-card>
              <b-card-text>
                <md-layout md-gutter v-if="pickupLocation.locationType == ''">
                  <md-layout md-flex="30">
                    <span style="color: red">
                      <u>Note:-Select Location Type to Continue..!</u>
                    </span>
                  </md-layout>
                </md-layout>

                <div v-if="pickupLocation.pickupId != ''">
                  <b-button class="pull-right" size="sm" variant="danger"
                    @click="deleteData(pickupLocation.pickupId)">Delete Location</b-button>
                </div>
                <md-layout md-gutter class="mt-2">
                  <md-layout md-flex="20">
                    <label for="locationType">Select Location Type</label>
                    <model-list-select :list="LocationTypeList" v-model="pickupLocation.locationType"
                      option-value="LocationTypeVal" option-text="LocationTypeText"
                      placeholder="Select Location Type"></model-list-select>

                    <span class="error" v-if="!pickupLocation.locationType">{{
                      locationTypeError
                    }}</span>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20">
                    <label>Enquiry Pricing</label>
                    <model-list-select :list="enqPriceList" v-model="pickupLocation.is_enq_price" option-value="val"
                      option-text="valTxt" placeholder="Select Enquiry Pricing"></model-list-select>
                    <span class="error" v-if="!pickupLocation.is_enq_price">{{
                      is_enq_priceError
                    }}</span>
                  </md-layout>

                  <!-- <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20" v-if="pickupLocation.locationType=='5'">
                    <label>Add Console Booking Pref</label><br/>
                    {{ pickupLocation.add_console_booking_pre }}
                    <md-switch
                      :id="'approval' + pickupLocation.add_console_booking_pre"
                      name="approval"
                      class="md-primary"
                      :value="pickupLocation.add_console_booking_pre === '1'"
                      @change="activateBookingPref(pickupLocation)"
                    >
                      <h6>
                        <b-badge style="margin-left: -45px">{{
                          pickupLocation.add_console_booking_pre
                            ? "Yes"
                            : "No"
                        }}</b-badge>
                      </h6>
                    </md-switch>
                  </md-layout> -->

                  <md-layout md-flex="5" v-if="pickupLocation.is_enq_price == 1"></md-layout>
                  <md-layout md-flex="20" v-if="pickupLocation.is_enq_price == 1">
                    <label>TERRITORY</label>
                    <b-form-input :formatter="capitalizeAll" id="enq_price_loc_territory" name="enq_price_loc_territory"
                      v-model="pickupLocation.enq_price_loc_territory" placeholder="Enter TERRITORY"></b-form-input>
                    <span class="error" v-if="!pickupLocation.enq_price_loc_territory">{{
                      enq_price_loc_territoryError
                    }}</span>
                  </md-layout>
                </md-layout>

                <md-layout md-gutter>
                  <md-layout md-flex="40" v-if="pickupLocation.locationType != ''">
                    <md-layout md-flex="100">
                      <label v-if="
                        pickupLocation.locationType == 'Client_Factory' ||
                        pickupLocation.locationType == 'Icd' ||
                        pickupLocation.locationType == '5' ||
                        pickupLocation.locationType == '6'
                      ">Location Name</label>
                      <label v-else>Port Name</label>
                      <!-- :disabled="pickupLocation.pickupId!='' && " -->
                      <b-form-input :formatter="capitalizeAll" id="mainLocation" name="mainLocation"
                        v-model="pickupLocation.mainLocation" @keyup="checkAlready"></b-form-input>

                      <span class="error" v-if="pickupLocationArrayError != ''">{{
                        pickupLocationArrayError
                      }}</span>
                    </md-layout>
                    <span class="error" v-if="!pickupLocation.mainLocation">{{
                      pickupLocationError
                    }}</span>
                  </md-layout>
                  <md-layout md-flex="5" v-if="pickupLocation.locationType == '5'"></md-layout>
                  <md-layout md-flex="10" v-if="pickupLocation.locationType == '5'">
                    <md-layout md-flex="100">
                      <label>Branch Code</label>
                      <b-form-input :formatter="capitalizeAll" id="BranchCode" name="BranchCode"
                        v-model="pickupLocation.BranchCode"></b-form-input>
                    </md-layout>
                    <span class="error" v-if="!pickupLocation.BranchCode">{{
                      BranchCodeError
                    }}</span>
                  </md-layout>
                  <md-layout md-flex="5" v-if="pickupLocation.locationType == '5'"></md-layout>
                  <md-layout md-flex="25" v-if="pickupLocation.locationType == '5'">
                    <md-layout md-flex="100">
                      <label> Default Billing Branch</label>
                      <model-list-select @input="getBillingBranch" :list="billingLocationData"
                        v-model="pickupLocation.billingLocationId" option-value="billingLocationId"
                        option-text="billingLocation" placeholder="Select Billing Location"></model-list-select>
                    </md-layout>
                  </md-layout>
                  <md-layout md-flex="5" v-if="
                    pickupLocation.locationType == 'Client_Factory' ||
                    pickupLocation.locationType == 'Icd'
                  "></md-layout>
                  <md-layout md-flex="25" v-if="
                    pickupLocation.locationType == 'Client_Factory' ||
                    pickupLocation.locationType == 'Icd'
                  ">
                    <md-layout md-flex="100">
                      <label>Latitude</label>
                      <b-form-input :formatter="capitalizeAll" type="number" min="0" id="latitude" name="latitude"
                        v-model="pickupLocation.latitude"></b-form-input>
                    </md-layout>
                    <span class="error" v-if="!pickupLocation.latitude">{{
                      latitudeError
                    }}</span>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="10" v-if="
                    pickupLocation.locationType == 'Sea_Port' ||
                    pickupLocation.locationType == 'Air_Port'
                  ">
                    <md-layout md-flex="100">
                      <label>Port Code</label>
                      <b-form-input :formatter="capitalizeAll" id="portCode" name="portCode"
                        v-model="pickupLocation.portCode"></b-form-input>
                    </md-layout>
                    <span class="error" v-if="!pickupLocation.portCode">{{
                      portCodeError
                    }}</span>
                  </md-layout>

                  <md-layout md-flex="5" v-if="
                    pickupLocation.locationType == 'Sea_Port' ||
                    pickupLocation.locationType == 'Air_Port'
                  "></md-layout>
                  <md-layout md-flex="15" v-if="
                    pickupLocation.locationType == 'Sea_Port' ||
                    pickupLocation.locationType == 'Air_Port'
                  ">
                    <label for="portlocationType">Port Type</label>
                    <model-list-select :list="portLocationTypeList" v-model="pickupLocation.portLocationType"
                      option-value="portLocationTypeVal" option-text="portLocationTypeText"
                      placeholder="Select Port Type"></model-list-select>

                    <span class="error" v-if="!pickupLocation.portLocationType">{{
                      portlocationTypeError
                    }}</span>
                  </md-layout>
                  <md-layout md-flex="5" v-if="
                    pickupLocation.locationType == 'Sea_Port' ||
                    pickupLocation.locationType == 'Air_Port'
                  "></md-layout>
                  <md-layout md-flex="20" v-if="
                    pickupLocation.locationType == 'Sea_Port' ||
                    pickupLocation.locationType == 'Air_Port'
                  ">
                    <md-layout md-flex="100">
                      <label>Port Location (Country Name)</label>
                      <b-form-input :formatter="capitalizeAll" id="portLocation" name="portLocation"
                        v-model="pickupLocation.portLocation"></b-form-input>
                    </md-layout>
                  </md-layout>
                  <md-layout md-flex="25" v-if="
                    pickupLocation.locationType == 'Client_Factory' ||
                    pickupLocation.locationType == 'Icd'
                  ">
                    <md-layout md-flex="100">
                      <label>Longitude</label>
                      <b-form-input :formatter="capitalizeAll" type="number" min="0" id="longitude" name="longitude"
                        v-model="pickupLocation.longitude"></b-form-input>
                    </md-layout>
                    <span class="error" v-if="!pickupLocation.longitude">{{
                      longitudeError
                    }}</span>
                  </md-layout>
                </md-layout>
                <md-layout md-gutter class="gutr" v-if="
                  pickupLocation.locationType == 'Sea_Port' ||
                  pickupLocation.locationType == 'Air_Port'
                ">
                  <md-layout md-flex="40">
                    <md-layout md-flex="100">
                      <label>State Name</label>
                      <b-form-input :formatter="capitalizeAll" id="mainLocation" name="mainLocation"
                        v-model="pickupLocation.stateName"></b-form-input>
                    </md-layout>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="10">
                    <md-layout md-flex="100">
                      <label>State Code</label>
                      <b-form-input :formatter="capitalizeAll" id="portCode" name="portCode"
                        v-model="pickupLocation.stateCode"></b-form-input>
                    </md-layout>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="40">
                    <md-layout md-flex="100">
                      <label>Special Instruction</label>
                      <b-form-textarea :formatter="capitalizeAll" name="address" id="address"
                        v-model="pickupLocation.specialInstruction"></b-form-textarea>
                    </md-layout>
                  </md-layout>
                </md-layout>

                <md-layout md-gutter v-if="
                  (pickupLocation.locationType != '' &&
                    pickupLocation.locationType != 'Sea_Port') ||
                  pickupLocation.locationType != 'Air_Port'
                ">
                  <md-layout md-flex="100">
                    <md-layout md-flex="100">
                      <label>Address</label>
                      <b-form-textarea :formatter="capitalizeAll" name="address" id="address"
                        v-model="pickupLocation.address"></b-form-textarea>
                    </md-layout>
                  </md-layout>
                </md-layout>
                <md-layout md-gutter class="mt-3" v-if="pickupLocation.locationType != ''">
                  <md-layout class="justify-content-center">
                    <!-- :disabled="
                        pickupLocation.locationType == 'Client_Factory'
                          ? true
                          : false
                      " -->
                    <b-button class="smbutnWidth" variant="primary" @click="addVehicleSize"
                      id="addButtonLoader">Save</b-button>
                    <span class="error" v-if="
                      pickupLocation.locationType == 'Client_Factory' &&
                      pickupLocation.pickupId != ''
                    ">Please Add Client Factory From Client Master</span>
                    <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
                  </md-layout>
                </md-layout>
              </b-card-text>
            </b-card>
          </div>
          <!--  <md-layout md-gutter>
            <md-layout md-flex="30">
              <h3>Location Details</h3>
            </md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <md-input-container>
                  <label>Upload File</label>
                  <md-file
                    name="excelUpload"
                    id="excelUpload"
                    v-model="excelUpload"
                    @selected="onFileChange()"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  ></md-file>
                </md-input-container>
              </md-layout>
            </md-layout>
            <md-layout md-flex="20"></md-layout>
            <md-layout md-flex="20">
              <md-button
                class="md-raised md-primary md-button-color heght-1px"
                @click="downloadExcel"
                id
              >Download Excel</md-button>
            </md-layout>
          </md-layout>-->
        </div>
        <div>
          <h5 class="text-muted pull-right mt-2 ml-3">
            <small>{{ totalRows }} Entries</small>
          </h5>
        </div>

        <md-layout md-gutter class="mt-2">
          <md-layout md-flex="100">
            <b-form-input :formatter="capitalizeAll" v-model="filter" placeholder="Type to Search"
              @input="getData('0', '1')"></b-form-input>
          </md-layout>
        </md-layout>

        <!-- User Interface controls -->
        <b-row>
          <!-- <b-col md="6" class="my-1">
              <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
                <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
              </b-form-group>
          </b-col>-->
        </b-row>

        <!-- Main table element -->
        <div class="table-responsive tableMain mt-3">
          <b-table show-empty stacked="md" :items="vehicleSizeMaster" :fields="fields" :per-page="perPage"
            :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
            <template slot="locationType" slot-scope="row">
              <span>{{
                row.value == "5" ? "Pridel Branch" : row.value == "6" ? "CFS" : row.value
              }}</span>
            </template>

            <template slot="pickupLocation" slot-scope="row">
              <span @click="editLocation(row.item)" class="showMoreData">{{
                row.value
              }}</span><br />

            </template>
            <template slot="pickupId" slot-scope="row2">
              {{ row2.item.pickupId }}
              <div v-if="adminToggle == 'Admin'" :id="'row' + row2.item.pickupId">
                <md-switch :id="'approval' + row2.item.pickupId" name="approval" class="md-primary"
                  :value="row2.item.pickupIsActive == 1 ? true : false" @change="activateUser(row2.item)">
                  <h6>
                    <br />
                    <b-badge style="margin-left: -45px">{{
                      row2.item.pickupIsActive == 1 ? "Active" : "In-Active"
                    }}</b-badge>
                  </h6>
                </md-switch>
              </div>
              <div v-else :id="'row' + row2.item.pickupId">
                <h6>
                  <b-badge>{{
                    row2.item.pickupIsActive == 1 ? "Active" : "In-Active"
                  }}</b-badge>
                </h6>
              </div>
            </template>
            <template slot="add_console_booking_pre" slot-scope="row">

              <md-switch v-if="row.item.locationType == '5'" :id="'approval' + row.item.add_console_booking_pre"
                name="approval" class="md-primary" :value="row.item.add_console_booking_pre === '1'"
                @change="activateBookingPref(row.item)">
                <h6>
                  <b-badge style="margin-left: -45px">{{
                    row.item.add_console_booking_pre == 1
                      ? "Yes"
                      : "No"
                  }}</b-badge>
                </h6>
              </md-switch>
            </template>
             <template slot="is_noe_validation" slot-scope="row">

              <md-switch v-if="row.item.locationType == '5'" :id="'approval' + row.item.is_noe_validation"
                name="approval" class="md-primary" :value="row.item.is_noe_validation === '1'"
                @change="activateNatureOfExpensePref(row.item)">
                <h6>
                  <b-badge style="margin-left: -45px">{{
                    row.item.is_noe_validation == 1
                      ? "Yes"
                      : "No"
                  }}</b-badge>
                </h6>
              </md-switch>
            </template>
            <template slot="is_expense_validation" slot-scope="row">

              <md-switch v-if="row.item.locationType == '5'" :id="'approval' + row.item.is_expense_validation"
                name="approval" class="md-primary" :value="row.item.is_expense_validation === '1'"
                @change="activateExpensePref(row.item)">
                <h6>
                  <b-badge style="margin-left: -45px">{{
                    row.item.is_expense_validation == 1
                      ? "Yes"
                      : "No"
                  }}</b-badge>
                </h6>
              </md-switch>
            </template>
            <template slot="is_additional_task_validation" slot-scope="row">

<md-switch v-if="row.item.locationType == '5'" :id="'approval' + row.item.is_additional_task_validation"
  name="approval" class="md-primary" :value="row.item.is_additional_task_validation === '1'"
  @change="activateAdditionalTaskPref(row.item)">
  <h6>
    <b-badge style="margin-left: -45px">{{
      row.item.is_additional_task_validation == 1
        ? "Yes"
        : "No"
    }}</b-badge>
  </h6>
</md-switch>
</template>
<template slot="is_sline_validation" slot-scope="row">

<md-switch v-if="row.item.locationType == '5'" :id="'approval' + row.item.is_sline_validation"
  name="approval" class="md-primary" :value="row.item.is_sline_validation === '1'"
  @change="activateSlinePref(row.item)">
  <h6>
    <b-badge style="margin-left: -45px">{{
      row.item.is_sline_validation == 1
        ? "Yes"
        : "No"
    }}</b-badge>
  </h6>
</md-switch>
</template>
          </b-table>
        </div>

        <div>
          <b-pagination limit="5" align="center" v-model="currentPage" :per-page="perPage" :total-rows="totalRows"
            @change="onPageChange($event)"></b-pagination>
        </div>

        <!-- Info modal -->
      </b-card-text>
    </b-card>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>

    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" @close="onClose6"
      ref="addPop6"></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../../helper/filters";
import { globalPermissionStatus } from "../../../helper/collection";
import XLSX from "xlsx";
import ClientUserService from "../../../services/ClientUserService";

export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/location/pickupLocation");
      if (globalPermissionStatus("locaionMaster") != "Disabled") {
        this.$sessionsStorage.set(
          "PermissionStatus",
          globalPermissionStatus("locaionMaster")
        );
      } else {
        this.$router.push({
          path: "/dashboard",
        });
      }

      this.getData("0", "1", "1");
    } else {
      this.$router.push({
        path: "/Login/",
      });
    }
  },
  data() {
    return {
      Status: "2",
      adminToggle: this.$sessionsStorage.get("designation"),
      locationTypeFilter: "",
      ExcelBtnName: "Export to Excel",
      fields: [
      {
          key: "pickupId",
          mainkey: "pickupId",
          label: "Location ID",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "pickupLocation",
          mainkey: "pickupLocation",
          label: "Location Name",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "locationType",
          mainkey: "locationType",
          label: "Location Type",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "latitude",
          mainkey: "latitude",
          label: "Location Latitude",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "longitude",
          mainkey: "longitude",
          label: "Location longitude",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "portLocationType",
          mainkey: "portLocationType",
          label: "Port Location",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "portLocation",
          mainkey: "portLocation",
          label: "Country",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "pickupId",
          mainkey: "pickupId",
          label: "Status",
          sortable: true,
          sortDirection: "ASC",
        },
         {
          key: "is_noe_validation",
          mainkey: "is_noe_validation",
          label: "Nature of Expense Validation(Billing)",
          sortable: true,
          sortDirection: "ASC",
        },
      {
          key: "is_expense_validation",
          mainkey: "is_expense_validation",
          label: "Purchase Expense Validation",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "is_additional_task_validation",
          mainkey: "is_additional_task_validation",
          label: "Additional Task Validation",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "is_sline_validation",
          mainkey: "is_sline_validation",
          label: "SLine Validation",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "add_console_booking_pre",
          mainkey: "add_console_booking_pre",
          label: "Add Console Booking Pref",
          sortable: true,
          sortDirection: "ASC",
        },
      ],
      billingLocationData: [],
      totalRows: 1,
      currentPage: 2,

      perPage: 20,
      pageOptions: [20, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,

      showMain: false,
      isLoading: "",
      LocationTypeNameFilter: [
        {
          LocationTypeVal: "Icd",
          LocationTypeText: "Icd",
        },
        {
          LocationTypeVal: "Client_Factory",
          LocationTypeText: "Client Factory",
        },
        {
          LocationTypeVal: "5",
          LocationTypeText: "Pridel Branch",
        },
        {
          LocationTypeVal: "6",
          LocationTypeText: "CFS",
        },

        {
          LocationTypeVal: "Sea_Port",
          LocationTypeText: "Sea Port",
        },
        {
          LocationTypeVal: "Air_Port",
          LocationTypeText: "Air Port",
        },
        {
          LocationTypeVal: "Vendor/Billing",
          LocationTypeText: "Vendor/Billing",
        },
        {
          LocationTypeVal: "All",
          LocationTypeText: "All",
        },
      ],
      LocationTypeName: [
        {
          LocationTypeVal: "Icd",
          LocationTypeText: "Icd",
        },
        {
          LocationTypeVal: "Client_Factory",
          LocationTypeText: "Client Factory",
        },
        {
          LocationTypeVal: "5",
          LocationTypeText: "Pridel Branch",
        },
        {
          LocationTypeVal: "6",
          LocationTypeText: "CFS",
        },

        {
          LocationTypeVal: "Sea_Port",
          LocationTypeText: "Sea Port",
        },
        {
          LocationTypeVal: "Air_Port",
          LocationTypeText: "Air Port",
        },
        {
          LocationTypeVal: "Vendor/Billing",
          LocationTypeText: "Vendor/Billing",
        },
      ],
      portLocationTypeName: [
        {
          portLocationTypeVal: "NON_USA",
          portLocationTypeText: "Non USA",
        },
        {
          portLocationTypeVal: "USA",
          portLocationTypeText: "USA",
        },
      ],
      portlocationTypeError: "",
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      excelUpload: "",
      pickupLocation: {
        billingLocationId: "",
        is_enq_price: "0",
        enq_price_loc_territory: "",
        allBranchIds: "",
        allBranchNames: "",
        billingLocationIdNew: "",
        billingLocationIdOld: "",
        allBranchIdsNew: "",
        allBranchNamesNew: "",
        specialInstruction: "",
        stateName: "",
        stateCode: "",
        pickupId: "",
        mainLocation: "",
        pickupLocation: "",
        latitude: "",
        longitude: "",
        locationType: "",
        portName: "",
        portLocation: "",
        portCode: "",
        address: "",
        BranchCode: "",

        portLocationType: "",
      },
      tempvehicleSizeMaster: [],

      portLocationTypeError: "",
      longitudeError: "",
      latitudeError: "",
      BranchCodeError: "",

      portCodeError: "",
      portNameError: "",
      vehicleSizeMaster: [{}],
      validate: true,
      pickupLocationError: "",
      locationTypeError: "",
      is_enq_priceError: "",
      enq_price_loc_territoryError: "",
      deleteId: "",
      pickupLocationArrayError: "",
      startPageNumber: 0,
      endPageNumber: 100,
      perPageDatacount: 50,

      // Excel Section Start

      columns2: [
        "SN",
        "Pickup_Id",
        "Location_Type",
        "Location_Name",
        "Main_Location_Name",
        "Branch_Code",
        "Location_Latitude",
        "Location_Longitude",
        "Port_Location_Type",
        "Port_Location",
        "Port_Code",
        "Country",
        "State_Name",
        "State_Code",
        "Address",
        "amsForNonUs",
        "Status",
      ],
      data2: [],
      options2: {
        headings: {
          SN: "SN.",
          Pickup_Id: "Pickup Id",
          Location_Type: "Location Type",
          Location_Name: "Location Name",
          Main_Location_Name: "Main Location Name",
          Branch_Code: "Branch Code",
          Location_Latitude: "Location Latitude",
          Location_Longitude: "Location Longitude",
          Port_Location_Type: "Port Location Type",
          Port_Location: "Port Location",
          Port_Code: "Port Code",
          Country: "Country",
          State_Name: "State Name",
          State_Code: "State Code",
          Address: "Address",
          amsForNonUs: "amsForNonUs",
          Status: "Status",
        },
      },
      StatusTypeList: [
        {
          StatusTypeVal: "0",
          StatusTypeTxt: "In-Active",
        },
        {
          StatusTypeVal: "1",
          StatusTypeTxt: "Active",
        },
        {
          StatusTypeVal: "2",
          StatusTypeTxt: "All",
        },
      ],
      enqPriceList: [
        {
          val: "1",
          valTxt: "Yes",
        },
        {
          val: "0",
          valTxt: "No",
        },
      ],
      // Excel Section End
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  mounted() { },

  beforeDestroy() { },

  destroyed() { },

  components: {
    DatePicker,
    ModelListSelect,
    Loading,
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    LocationTypeList() {
      return this.LocationTypeName;
    },
    portLocationTypeList() {
      return this.portLocationTypeName;
    },
  },

  methods: {
    activateUser(item, index) {
      // $("#approval" + id).val();

      this.itemObj = item;
      this.indexNew = index;

      this.deleteId = item.pickupId;

      this.itemObj.pickupIsActive = this.itemObj.pickupIsActive == 1 ? 0 : 1;
      let paylod = {
        tableName: "pickuplocationmaster",
        tableId: "pickupId",
        tableIsActive: "pickupIsActive",
        value1: this.itemObj.pickupIsActive,
        tableVal: this.deleteId,
        isMailSend: "No",
        manual: "No",
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/activateUser.php`,
        data: JSON.stringify(paylod),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.getData("0", "1", "1");
          }
        })
        .catch((error) => { });
    },
    ExportAccountExcel() {
      this.Excel_Location_Data = this.vehicleSizeMaster;
      if (this.Excel_Location_Data.length > 0) {
        let mainArray = [];
        this.data2.map((x) => {
          let tempArray = [];
          this.Excel_Location_columns.map((y) => {
            if (x.hasOwnProperty(y)) {
              tempArray[y] = x[y];
            }
          });
          mainArray.push(tempArray);
        });
        let dashboardName = "Pridel";
        var dataOne = XLSX.utils.json_to_sheet(mainArray);
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, dataOne, "Location_List"); // sheetAName is name of Worksheet
        XLSX.writeFile(
          wb,
          `${dashboardName.toUpperCase()}_Location_List_Report_${new Date().toDateString()}.xlsx`
        );
      }
    },
    getBillingBranch() {
      let arryNewBillBranch = [];

      arryNewBillBranch = this.billingLocationData.filter((x) => {
        return x.billingLocationId == this.pickupLocation.billingLocationId;
      });
      if (arryNewBillBranch.length > 0) {
        this.pickupLocation.billingLocationIdNew = arryNewBillBranch[0].billingLocationId;
        this.pickupLocation.allBranchIdsNew = arryNewBillBranch[0].branchLocation;
        this.pickupLocation.allBranchNamesNew = arryNewBillBranch[0].branchName;
      }
    },

    getData(CURRENT, SEARCH, pageNumber) {
      this.isLoading = true;
      let options2 = {
        searchVal: this.filter,
        fields: this.fields,
        fromSearch: SEARCH || 1,
        currentPage: CURRENT,
        perPage: this.perPage,
        sortById: "pickupId",
        Status:this.Status,
        ImpFields: [
          // {
          //   key: "locationType",
          //   value: "Icd,Client_Factory,5,6"
          // },
          {
            key: "pickupIsActive",
            value: this.Status?this.Status:"1",
          },
        ],
        tableName: "pickuplocationmaster",
        locationTypeFilter: this.locationTypeFilter,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/getPaginationData.php`,
        data: JSON.stringify(options2),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // Authorization: this.$sessionsStorage.get("loginId")
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.vehicleSizeMaster = data.locationDetail;

            this.isLoading = false;

            if (SEARCH != "2") {
              this.currentPage = 1;
              this.totalRows = data.totalData;
            } else {
              this.currentPage = pageNumber;
            }
            if (data.billingLocationData) {
              this.billingLocationData = data.billingLocationData;
            }

            console.log(data);
          }
        })
        .catch();
    },
    onPageChange: function (event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }

      this.getData(CURRENT, "2", event);

      // let totalRows = 1064 / this.perPage;
      // if(this.totalRow )
    },

    // onFiltered(filteredItems) {
    //   console.log(filteredItems);
    //   // Trigger pagination to update the number of buttons/pages due to filtering
    //   this.totalRows = filteredItems.length;

    //   console.log(this.totalRows);
    // },
    goToMain() {
      this.showMain = true;
    },
    JqueryFun() {
      return $(function () {
        return $("#pickupLocationtable").DataTable();
      });
    },

    checkAlready() {
      if (this.pickupLocation.pickupId == "") {
        let arrayNew = this.vehicleSizeMaster.filter((x) => {
          return (
            x.mainLocation.toLowerCase() ==
            this.pickupLocation.mainLocation.toLowerCase() &&
            x.locationType == this.pickupLocation.locationType
          );
        });

        if (arrayNew.length > 0) {
          this.pickupLocationArrayError = "Location Already Exist";
          return false;
        } else {
          this.pickupLocationArrayError = "";
        }
      }
    },

    validateAddVehicleSizeForm() {
      let validate_new = true;
      if (this.pickupLocation.mainLocation == "") {
        $("#mainLocation").focus();
        this.pickupLocationError = "Enter PickUp Location";
        validate_new = false;
      }

      if (this.pickupLocation.is_enq_price == 1) {
        if (this.pickupLocation.enq_price_loc_territory == "") {
          $("#enq_price_loc_territory").focus();
          this.enq_price_loc_territoryError = "Enter Territory Name";
          validate_new = false;
        }
      }

      if (this.pickupLocation.locationType == "5") {
        if (this.pickupLocation.BranchCode == "") {
          $("#BranchCode").focus();
          this.BranchCodeError = "Enter Branch Code ";
          validate_new = false;
        }
      }

      if (
        this.pickupLocation.locationType == "Client_Factory" ||
        this.pickupLocation.locationType == "Icd"
      ) {
        if (this.pickupLocation.latitude == "") {
          $("#latitude").focus();
          this.latitudeError = "Enter latitude ";
          validate_new = false;
        }

        if (this.pickupLocation.longitude == "") {
          $("#longitude").focus();
          this.longitudeError = "Enter longitude ";
          validate_new = false;
        }
      }
      if (
        this.pickupLocation.locationType == "Sea_Port" ||
        this.pickupLocation.locationType == "Air_Port"
      ) {
        if (this.pickupLocation.portCode == "") {
          $("#portCode").focus();
          this.portCodeError = "Enter Port Code ";
          validate_new = false;
        }
        if (this.pickupLocation.portLocationType == "") {
          $("#portlocationType").focus();
          this.portlocationTypeError = "Select  Port Type ";
          validate_new = false;
        }
      }
      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    addVehicleSize() {
      if (this.pickupLocation.pickupId == "") {
        let arrayNew = this.vehicleSizeMaster.filter((x) => {
          return (
            x.mainLocation.toLowerCase() ==
            this.pickupLocation.mainLocation.toLowerCase() &&
            x.locationType == this.pickupLocation.locationType
          );
        });

        if (arrayNew.length > 0) {
          this.pickupLocationArrayError = "Location Already Exist";
          return false;
        } else {
          this.pickupLocationArrayError = "";
        }
      }

      if (this.pickupLocation.locationType != "") {
        this.pickupLocation.pickupLocation = this.pickupLocation.mainLocation;
      }

      this.validateAddVehicleSizeForm();
      if (this.validate != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Master/addPickupLocation.php`,
          data: JSON.stringify(this.pickupLocation),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            $("#addButtonLoader").css("display", "block");
            $("#loader").css("display", "none");
            if (result.data.Id != "" && result.data.Id != undefined) {
              // window.location.reload(true);
              if (this.pickupLocation.pickupId != "") {
                this.alert.content = "Data updated Successfully";
              } else {
                this.alert.content = "Data Added Successfully";
              }
              this.getData("0", "1", "1");
              $("#pickupLocationtable").DataTable();

              this.$refs["addPop"].open();
              this.pickupLocation.mainLocation = "";
              this.pickupLocation.pickupId = "";
              this.pickupLocation.latitude = "";
              this.pickupLocation.longitude = "";
              this.pickupLocationError = "";
              this.longitudeError = "";
              this.latitudeError = "";
              this.pickupLocation.locationType = "";
              this.pickupLocation.mainLocation = "";
              this.pickupLocation.portLocation = "";
              this.pickupLocation.address = "";

              this.portCodeError = "";
              this.portlocationType = "";
              this.portlocationTypeError = "";
              this.showMain = false;
            }
          })
          .catch((error) => { });
      }
    },

    editLocation(item) {
      this.showMain = true;
      console.log(item);

      Object.keys(item).map((x) => {
        this.pickupLocation[x] = item[x] || "";
      });
      window.scrollTo(800, 0);
      for (let r = 0; r < this.billingLocationData.length; r++) {
        if (this.billingLocationData[r].branchLocation) {
          let allLocIds = [];
          allLocIds = this.billingLocationData[r].branchLocation.split(",");
          let arryNewBillBranch = [];
          arryNewBillBranch = allLocIds.filter((x) => {
            return x == this.pickupLocation.pickupId;
          });

          if (arryNewBillBranch.length > 0) {
            this.pickupLocation.billingLocationId = this.billingLocationData[
              r
            ].billingLocationId;
            this.pickupLocation.billingLocationIdOld = this.billingLocationData[
              r
            ].billingLocationId;
            this.pickupLocation.allBranchIds = this.billingLocationData[r].branchLocation;

            this.pickupLocation.allBranchNames = this.billingLocationData[r].branchName;
            let indexP = allLocIds.indexOf(this.pickupLocation.pickupId);
            if (this.pickupLocation.allBranchIds) {
              let a1 = this.pickupLocation.allBranchIds.split(",");
              a1.splice(indexP, 1);
              this.pickupLocation.allBranchIds = a1.toString();
            }
            if (this.pickupLocation.allBranchNames) {
              let a2 = this.pickupLocation.allBranchNames.split(",");
              a2.splice(indexP, 1);
              this.pickupLocation.allBranchNames = a2.toString();
            }
            console.log(
              this.pickupLocation.allBranchIds,
              "==",
              this.pickupLocation.allBranchNames
            );
            this.getBillingBranch();
            return false;
            break;
          }
        }
      }
    },
    downloadExcel() {
      let excelName = {
        excelName: "LocationMaster",
        validExcel: "yes",
      };
      this.ExcelBtnName = "Downloading Please Wait...";
      let options = {
        method: "POST",
        url: `${URL_BASE}/downloadMasterExcel.php`,
        data: JSON.stringify(excelName),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.ExcelBtnName = "Export To Excel";
            // console.log(data);
            // console.log(data.link12);

            window.open(data.link12);
          }
        })
        .catch((error) => { });
    },

    onFileChange() {
      var files = event.target.files || event.dataTransfer.files;
      // this.uploadCheck = files[0];
      var formData = new FormData();

      for (let i = 0; i < files.length; i++) {
        formData.append(`locationMaster[]`, files[i]);
      }
      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios
        .post(`${URL_BASE}/uploadExcelDataMaster.php`, formData, config)
        .then((result) => {
          console.log(result.data);
          if (result.data == "Only XLXS Format Support") {
            this.alert.content = "Only .xlxs format support";
          } else {
            this.alert.content = result.data;
          }
          this.$refs["addPop"].open();
          this.getData("0", "1", "1");
        })
        .catch((err) => {
          throw err;
        });
    },
    deleteData(id) {
      // console.log("sfsfsf",id)
      // return false;
      this.deleteId = id;
      this.alert.content = "Are you sure you want to delete this item?";
      this.$refs["addPop6"].open();
    },
    activateNatureOfExpensePref(item) {
      // this.pickupLocation.add_console_booking_pre = !item.add_console_booking_pre;

      this.itemObj = item;

      this.itemObj.is_noe_validation = this.itemObj.is_noe_validation == 1 ? 0 : 1;
      let paylod = {
        tableName: "pickuplocationmaster",
        tableId: "pickupId",
        tableIsActive: "is_noe_validation",
        value1: this.itemObj.is_noe_validation,
        tableVal: item.pickupId,
        isMailSend: 'No',
        manual: 'No',
      };

      ClientUserService.getAllActive(JSON.stringify(paylod))
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.getData("0", "1", "1");
          }
        })
        .catch((error) => {
          console.log("Catch on activateBookingPref Error: ", error);
        });

      console.log('this.pickupLocation.is_noe_validation=>', this.pickupLocation.is_noe_validation)
    },
    activateExpensePref(item) {
      // this.pickupLocation.add_console_booking_pre = !item.add_console_booking_pre;

      this.itemObj = item;

      this.itemObj.is_expense_validation = this.itemObj.is_expense_validation == 1 ? 0 : 1;
      let paylod = {
        tableName: "pickuplocationmaster",
        tableId: "pickupId",
        tableIsActive: "is_expense_validation",
        value1: this.itemObj.is_expense_validation,
        tableVal: item.pickupId,
        isMailSend: 'No',
        manual: 'No',
      };

      ClientUserService.getAllActive(JSON.stringify(paylod))
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.getData("0", "1", "1");
          }
        })
        .catch((error) => {
          console.log("Catch on activateBookingPref Error: ", error);
        });

      console.log('this.pickupLocation.is_expense_validation=>', this.pickupLocation.is_expense_validation)
    },
    activateAdditionalTaskPref(item) {
      // this.pickupLocation.add_console_booking_pre = !item.add_console_booking_pre;

      this.itemObj = item;

      this.itemObj.is_additional_task_validation = this.itemObj.is_additional_task_validation == 1 ? 0 : 1;
      let paylod = {
        tableName: "pickuplocationmaster",
        tableId: "pickupId",
        tableIsActive: "is_additional_task_validation",
        value1: this.itemObj.is_additional_task_validation,
        tableVal: item.pickupId,
        isMailSend: 'No',
        manual: 'No',
      };

      ClientUserService.getAllActive(JSON.stringify(paylod))
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.getData("0", "1", "1");
          }
        })
        .catch((error) => {
          console.log("Catch on activateBookingPref Error: ", error);
        });

      console.log('this.pickupLocation.is_additional_task_validation=>', this.pickupLocation.is_additional_task_validation)
    },
    activateSlinePref(item) {
      // this.pickupLocation.add_console_booking_pre = !item.add_console_booking_pre;

      this.itemObj = item;

      this.itemObj.is_sline_validation = this.itemObj.is_sline_validation == 1 ? 0 : 1;
      let paylod = {
        tableName: "pickuplocationmaster",
        tableId: "pickupId",
        tableIsActive: "is_sline_validation",
        value1: this.itemObj.is_sline_validation,
        tableVal: item.pickupId,
        isMailSend: 'No',
        manual: 'No',
      };

      ClientUserService.getAllActive(JSON.stringify(paylod))
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.getData("0", "1", "1");
          }
        })
        .catch((error) => {
          console.log("Catch on activateBookingPref Error: ", error);
        });

      console.log('this.pickupLocation.is_sline_validation=>', this.pickupLocation.is_sline_validation)
    },
    activateBookingPref(item) {
      // this.pickupLocation.add_console_booking_pre = !item.add_console_booking_pre;

      this.itemObj = item;

      this.itemObj.add_console_booking_pre = this.itemObj.add_console_booking_pre == 1 ? 0 : 1;
      let paylod = {
        tableName: "pickuplocationmaster",
        tableId: "pickupId",
        tableIsActive: "add_console_booking_pre",
        value1: this.itemObj.add_console_booking_pre,
        tableVal: item.pickupId,
        isMailSend: 'No',
        manual: 'No',
      };

      ClientUserService.getAllActive(JSON.stringify(paylod))
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.getData("0", "1", "1");
          }
        })
        .catch((error) => {
          console.log("Catch on activateBookingPref Error: ", error);
        });

      console.log('this.pickupLocation.add_console_booking_pre=>', this.pickupLocation.add_console_booking_pre)
    },
    onClose6(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "pickuplocationmaster",
          tableId: "pickupId",
          tableIsActive: "pickupIsActive",
          tableVal: this.deleteId,
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deleteData.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (data.clientId != "" && status == 200 && data) {
              this.JqueryFun();
              this.getData("0", "1", "1");
              this.pickupLocation.mainLocation = "";
              this.pickupLocation.pickupId = "";
              this.pickupLocation.latitude = "";
              this.pickupLocation.longitude = "";
              this.pickupLocationError = "";
              this.longitudeError = "";
              this.latitudeError = "";
              this.pickupLocation.locationType = "";
              this.pickupLocation.mainLocation = "";
              this.pickupLocation.portLocation = "";
              this.pickupLocation.address = "";

              this.portCodeError = "";
              // console.log(data);
            }
          })
          .catch((error) => { });
      }
    },
    getReportsAss(id, btnName) {
      let excelIdGivin = "";
      if (id == "All_Location_Master_Report") {
        excelIdGivin = "All_Location_Master_Report";
      }
      let payload = {
        excelId: excelIdGivin,
        assignmentNo: "PickupLocation",
        locationTypeFilter: this.locationTypeFilter,
      };
      this.ExcelBtnName = "Downloading Please Wait...";
      this.$store.dispatch(
        "common/setAllPendingReverseTallyExcel",
        JSON.stringify(payload)
      );
      let ExcelName = "";
      if (this.$store.getters["common/getAllPendingReverseTallyExcel"]) {
        this.ExcelBtnName = btnName;
        ExcelName = this.$store.getters["common/getAllPendingReverseTallyExcel"];
      }
    },
  },
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}

.mrgtop-2per {
  margin-top: 1%;
}

.mrgtop-5px {
  margin-top: 0px;
}

.center {
  text-align: center;
}

.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}

.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// pickupLocation.vue?6b32d324